export function useZendeskWidget() {
    const isOpen = useState<boolean>('zendesk-widget-open', () => false)

    const open = () => {
        isOpen.value = true
    }

    const hide = () => {
        isOpen.value = false
    }

    return {
        isOpen,
        open,
        hide,
    }
}
